<mat-form-field class="col-md-12">
  <mat-label>{{ title() }}</mat-label>
  <input matInput
    [formControl]="control()">
  @if (control().errors) {
    <mat-error>
      {{getError()}}
    </mat-error>
  }
</mat-form-field>
